import { isValid, parse } from "date-fns";
import {
  ProjectFormValues,
  ValidationFormErrors,
  ValidationFormsModeEnum,
} from "./types";
import { uk } from "date-fns/locale";

export function validateProject(
  values: ProjectFormValues,
  mode: ValidationFormsModeEnum,
  original?: ProjectFormValues
): ValidationFormErrors {
  const errors: ValidationFormErrors = {};

  if (!values.name || values.name.trim() === "") {
    errors.name = "Назва проєкту обов’язкова.";
  }

  if (!values.client || values.client.trim() === "") {
    errors.client = "Виберіть клієнта.";
  }

  if (!values.responsibleContact || values.responsibleContact.trim() === "") {
    errors.responsibleContact = "Вкажіть відповідальну особу.";
  }

  if (!values.stage || values.stage === "") {
    errors.stage = "Вкажіть статус проєкту.";
  }

  if (!values.budget || isNaN(Number(values.budget))) {
    errors.budget = "Введіть коректний бюджет.";
  }

  if (
    !values.deadline ||
    !isValid(
      parse(values.deadline, "d MMMM yyyy", new Date(), {
        locale: uk,
      })
    )
  ) {
    errors.deadline = "Введіть коректну дату.";
  }

  if (
    values.members.length === 0 ||
    values.members.every((x) => {
      return x.email === "" || x.roleName === "";
    })
  ) {
    errors.members = "Перевірте коректність введений даних.";
  }

  if (mode === "edit" && original) {
    if (Number(values.budget) < Number(original.budget)) {
      errors.budget = "Бюджет не можна зменшувати.";
    }
  }

  return errors;
}
